<template>
    <div>
        <menu-bar/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/fibras"><i class="fa fa-suitcase" aria-hidden="true"></i> FIBRAS</a></li>
                    <li class="active">CADASTRO DE FIBRAS</li>
                </ol>

                <div class="col-md-3">
                    <voltar-menu :url="'#/fibras'" />
                </div>

                <div class="col-md-9">
                    <router-view></router-view>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { VoltarMenu } from "../../../components/exports";
export default {
    components: { VoltarMenu },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    }
};
</script>
